module.exports = __webpack_public_path__ + "img/sec2_13.1cf137e2.png";